import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "general-setting",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const generalSetting = require("./GeneralSetting").default;
          cb(null, generalSetting);
        },
        "GeneralSetting"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/GeneralSetting/index.js